import { render, staticRenderFns } from "./Half.vue?vue&type=template&id=feafca62&"
import script from "./Half.vue?vue&type=script&lang=js&"
export * from "./Half.vue?vue&type=script&lang=js&"
import style0 from "./Half.vue?vue&type=style&index=0&id=feafca62&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports